import { Box, Flex, Heading } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { getLocationsList } from "./utils/api";
import WaitTimesMap from "./WaitTimesMap";
import WaitTimesTable from "./WaitTimesTable";

const programTypeToName = {
  GLOBAL_ENTRY: "Global Entry",
  SENTRI: "SENTRI",
  NEXUS: "NEXUS",
};

const PAGE_STATES = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};
const WaitTimes = ({ programType }) => {
  const [locationData, setLocationData] = useState(null);

  const [pageState, setPageState] = useState(PAGE_STATES.LOADING);
  const [updatedAt, setUpdatedAt] = useState(null);
  useEffect(() => {
    const fetchAndSetLocationInfo = async () => {
      try {
        const data = await getLocationsList(programType);
        setLocationData(data.locations);
        setUpdatedAt(data.updatedAt);
        setPageState(PAGE_STATES.SUCCESS);
      } catch (err) {}
    };
    fetchAndSetLocationInfo();
  }, [programType]);

  return (
    <Flex flexDir="column" alignItems="center">
      <Box w="800px" height="500px" pos="absolute">
        <WaitTimesMap locations={locationData || []} />
      </Box>

      <Box maxW="1000px" pos="relative" mt="40vh">
        <WaitTimesTable
          programType={programType}
          locationData={locationData}
          setLocationData={setLocationData}
          updatedAt={updatedAt}
          pageState={pageState}
        />
      </Box>
    </Flex>
  );
};

export default WaitTimes;
